module.exports = __webpack_public_path__ + "media/images/assignment/sync_gray-8ba01f02d5fcf60e3ae70f009556edc3.svg";